import { useState, Key, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants';
import { ISaleRoFields, IDetailList, ISaleSoDetails } from './vrmBillSaleRoType';
import { IVRM2DictDetail, IVRM2DictSearchs, saleRoService } from './vrmBillSaleRoService';
import { forFind, formatNum } from '@/utils/utils';
import useStorageState from '@/hooks/useStorageState';
import useGlobalModel from '@/model/globalModel';

export type ISaleRoDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	discountAll: number;
	receivableAll: number;
	[key: string]: any;
};
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends ISaleSoDetails {
	num: number;
	// price?: number,
	// amount?: number,
	saleNum?: number;
	salePrice?: number;
	saleTotal?: number;
}

type dictObj = {
	[key: string]: any;
};

function listChangeTree(list: IVRM2DictDetail[]) {
	let menuObj: dictObj = {};
	list?.forEach((item) => {
		item.children = [];
		menuObj[item.code] = item;
	});
	return list?.filter((item) => {
		if (item.pcode !== null && item.pcode !== '') {
			menuObj[item.pcode]?.children.push(item);
			return false;
		}
		return true;
	});
}

export const useVrmSaleRoDetailModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		discountAll: 0, //折扣,
		receivableAll: 0, //应收
	};
	const { userBranch } = useGlobalModel()
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	// 云修系统数据字典
	const [treeSource, setTreeSource, clearTreeSource] = useStorageState<IVRM2DictDetail[]>(
		'vrmDictTree',
		[]
	); //字典数据源
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<ISaleRoFields>({});
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<ISaleRoDescType>(initDesc);

	useEffect(() => {
		let newDesc: ISaleRoDescType = initDesc;
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.amount);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList, detailLookForm]);

	// 获取云修系统的数据字典
	const loadVrmDictData = async (shopCodes?: string) => {
		let data: IVRM2DictSearchs = {
			sourceApp: 'vrm',
			pageSize: 10000000,
			pageNum: 1,
		};
		// let { retData } = await saleRoService.pages(data);
		// setTreeSource(listChangeTree(retData));
		setTreeSource(listChangeTree([]))
	};
	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await saleRoService.one(id, userBranch);
		if (retData) {
			const { details, settleDetails, ...from } = retData;
			const newDetails = details?.map((item) => {
				return {
					...item,
					notAmount: +formatNum(Number(item.num) * Number(item.price)),
					unitName: getVrmTreeNodeName(item.unitCode as string),
				};
			});
			setDetailLookForm({
				...from,
				vehicleTypeName: getVrmTreeNodeName(from.vehicleTypeCode as string),
				maintenanceTypeName: getVrmTreeNodeName(from.maintenanceTypeCode as string),
				settlementPartyName: getVrmTreeNodeName(from.settlementPartyCode as string),
				payType: getVrmTreeNodeName(from.payType as string),
				customerTypeName: getVrmTreeNodeName(from.customerTypeCode as string),
				invoiceTypeName: getVrmTreeNodeName(from.invoiceTypeCode as string),
			});
			setDetailLookList((newDetails as IDetailList[]) ?? []);
		}
	};

	//根据code 返回对应的node节点名称
	const getVrmTreeNodeName = (code: string): string => {
		let obj: dictObj = {};
		let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, 'code');
		return findTree ? findTree['name'] : '';
	};
	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookList([]);
		setDetailLookForm({});
	};
	return {
		initPgCfg,
		detailLookForm,
		detailLookList,
		lookDesc,
		treeSource,
		// model
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		loadVrmDictData,
		getVrmTreeNodeName,
		resetLookCatch,
	};
});
